/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'На базе Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'На базе AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Содержимое создано с учетом прав доступа. Качество информации может быть разным.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Качество контента может быть разным',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated':
    'Создано с помощью искусственного интеллекта. Проверьте результаты.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Информация',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Включить знания с текущей страницы',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Логотип Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Назад',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Отмена',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Отмена',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Отмена',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Плохой ответ',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Отзыв отправлен',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Хороший ответ',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Продолжить с последнего ответа',
  'fabric.editor.ai.config.item.action.copyResponse': 'Копировать',
  'fabric.editor.ai.config.item.action.responseCopied': 'Скопировано!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Скопировано в буфер обмена',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Повторить',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Не удается вставить ответ. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Не удалось получить ответ. Ваш запрос или ответ превысили ограничение для данного запроса. Закройте окно и повторите попытку.',
  'fabric.editor.ai.experience.apiError': 'Не удалось получить ответ, повторите попытку.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Скажите ИИ, что нужно сделать…',
  'fabric.editor.ai.experience.inputTooShortError':
    'Контент слишком короткий для создания сводки. Добавьте информацию и повторите попытку.',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'Rovo работает',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Выполняется генерация',
  'fabric.editor.ai.experience.loadingEditingTitle': 'Rovo редактирует',
  'fabric.editor.ai.experience.previewScreenLabel': 'Предпросмотр',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Попросите агента написать что-нибудь или выберите из списка ниже',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Логотип Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Назад',
  'fabric.editor.ai.screens.discard.discardLabel': 'Удалить',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Предупреждение',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Ошибка',
  'fabric.editor.ai.screens.error.cancelLabel': 'Отмена',
  'fabric.editor.ai.screens.error.retryLabel': 'Повторить попытку',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription':
    'Контент, обновляемый в режиме реального времени:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Значок: генерирование',
  'fabric.editor.ai.screens.noImprovement.closeLabel': 'Закрыть',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Ничего не нужно улучшать. Отличная работа!',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Готово',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Принять',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Действия с контентом, сгенерированным ИИ',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Повторить попытку',
  'fabric.editor.ai.screens.preview.betaLabel': 'Бета-версия',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Отмена',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Полезно?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Скажите AI, что делать дальше',
  'fabric.editor.ai.screens.preview.discardLabel': 'Удалить',
  'fabric.editor.ai.screens.preview.disclaimer': 'Качество информации может быть разным.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Узнайте, почему',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Очистить',
  'fabric.editor.ai.screens.preview.header.edit': 'Отредактировать запрос',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Изменить',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Спросите агента {agentName}, что делать дальше',
  'fabric.editor.ai.screens.preview.refineButton': 'Улучшить',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Улучшить',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Логотип Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Добавить ссылку',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Упомянуть пользователя',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Вставить форматированный контент',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Опишите, что вы хотите сделать',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Записать',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Отправить',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Отправить',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Отправить в AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': 'Выбрано: «{promptName}»',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Отменить',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Предложения',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Помощник по написанию текстов',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction':
    'Воспользуйтесь помощью Atlassian Intelligence в написании контента',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Написать',
  'fabric.editor.ai.shared.betaLabel': 'Бета-версия',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'БЕТА-ВЕРСИЯ',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'НОВОЕ',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Скажите AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Скажите агенту',
};
